import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import './_positionMedia';
import './_parallax';
import './_blockText';
import './_zoomOut';
import './_splitText';
import './_openMedia';
import './_blurMedia';

gsap.registerPlugin(ScrollTrigger);

const scrollDown = document.querySelectorAll('.js-scroll-down');
const scrollUp = document.querySelectorAll('.js-scroll-up');
const scrollLeft = document.querySelectorAll('.js-scroll-left');
const scrollRight = document.querySelectorAll('.js-scroll-right');
const scrollView = document.querySelectorAll('.js-scroll-view');
const scrollSkew = document.querySelectorAll('.js-scroll-skew');

const GetTriggerPoint = (trigger) => {
  const state = trigger.dataset.position;
  if (state == 'center' || !state) {
    return 'top bottom-=8%';
  } else if (state == 'bottom') {
    return 'top bottom-=8%';
  }
}

if (scrollDown) {
  scrollDown.forEach(elm => {
    let elmTl = gsap.timeline({
      scrollTrigger: {
        scrub: 2,
        trigger: elm,
        start: GetTriggerPoint(elm),
        end: () => '+=' + (elm.clientHeight - elm.clientHeight),
        // markers: true
      }
    })

    elm.style.transform = 'translate(0, -80px)';
    elm.style.opacity = 0;

    elmTl.addLabel('start')
      .to(elm, {
        y: 0,
        opacity: 1,
        duration: 1
      })
  })
}

if (scrollUp) {
  scrollUp.forEach(elm => {
    let elmTl = gsap.timeline({
      scrollTrigger: {
        scrub: 2,
        trigger: elm,
        start: GetTriggerPoint(elm),
        end: () => '+=' + (elm.clientHeight - elm.clientHeight),
        // markers: true
      }
    })

    elm.style.transform = 'translate(0, 80px)';
    elm.style.opacity = 0;

    elmTl.addLabel('start')
      .to(elm, {
        y: 0,
        opacity: 1,
        duration: 1,
        delay: .5
      })
  })
}

if (scrollLeft) {
  scrollLeft.forEach(elm => {
    let elmTl = gsap.timeline({
      scrollTrigger: {
        scrub: 2,
        trigger: elm,
        start: GetTriggerPoint(elm),
        end: () => '+=' + (elm.clientHeight - elm.clientHeight),
        // markers: true
      }
    })

    elm.style.transform = 'translate(-80px, 0)';
    elm.style.opacity = 0;

    elmTl.addLabel('start')
      .to(elm, {
        x: 0,
        opacity: 1,
        duration: 1,
        delay: .5
      })
  })
}

if (scrollRight) {
  scrollRight.forEach(elm => {
    let elmTl = gsap.timeline({
      scrollTrigger: {
        scrub: 2,
        trigger: elm,
        start: GetTriggerPoint(elm),
        end: () => '+=' + (elm.clientHeight - elm.clientHeight),
        // markers: true
      }
    })

    elm.style.transform = 'translate(80px, 0)';
    elm.style.opacity = 0;

    elmTl.addLabel('start')
      .to(elm, {
        x: 0,
        opacity: 1,
        duration: 1,
        delay: .5
      })
  })
}

if (scrollView) {
  scrollView.forEach(elm => {

    let elmTl = gsap.timeline({
      scrollTrigger: {
        scrub: 2,
        trigger: elm,
        start: GetTriggerPoint(elm),
        end: () => '+=' + (elm.clientHeight),
        // markers: true
      }
    })

    gsap.set(elm, {
      opacity: 0,
    })

    elmTl.addLabel('start')
      .to(elm, {
        opacity: 1,
        duration: 2,
        delay: 1
      })
    // .to(elm, {
    //   opacity: 1,
    //   duration: 2,
    //   delay: .5
    // })
  })
}

if (scrollSkew) {
  scrollSkew.forEach(elm => {
    let elmTl = gsap.timeline({
      scrollTrigger: {
        scrub: 2,
        trigger: elm,
        start: GetTriggerPoint(elm),
        end: () => '+=' + (elm.clientHeight - elm.clientHeight),
        // markers: true
      }
    })

    gsap.set(elm, {
      skewY: 4,
      transformOrigin: 'left top',
      y: 80,
      opacity: 0,
    })

    elmTl.addLabel('start')
      .to(elm, {
        skewY: 0,
        opacity: 1,
        y: 0,
        duration: 2,
        delay: .8
      })
  })
}